import React from 'react';
import { ClockIcon, CheckSquareIcon, PlayIcon, AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { BugunYapilacaklar } from './BugunYapilacaklar';
// Haftalık çalışma verisi
const weeklyData = [{
  day: 'Pzt',
  hours: 6
}, {
  day: 'Sal',
  hours: 4
}, {
  day: 'Çar',
  hours: 8
}, {
  day: 'Per',
  hours: 5
}, {
  day: 'Cum',
  hours: 7
}, {
  day: 'Cmt',
  hours: 8
}, {
  day: 'Paz',
  hours: 7
}];
export function VeliDashboard() {
  return <div className="space-y-6" data-id="element-355">
      {/* Üst Sıra - Yan Yana Kartlar */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-356">
        {/* Günlük Çalışma İstatistiği - FIX */}
        <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-357">
          <div className="relative p-6 bg-black/90 rounded-lg h-full" data-id="element-358">
            {' '}
            {/* p-6 ÖNEMLİ! */}
            <div className="space-y-4" data-id="element-359">
              <h3 className="text-gray-400 font-medium text-sm" data-id="element-360">
                Günlük Çalışma İstatistiği
              </h3>
              <div className="grid grid-cols-3 gap-4" data-id="element-361">
                <div className="text-center" data-id="element-362">
                  <ClockIcon className="w-8 h-8 text-blue-400 mx-auto mb-2" data-id="element-363" />
                  <div className="text-2xl font-bold text-white" data-id="element-364">8 saat</div>
                  <div className="text-sm text-gray-400" data-id="element-365">Çalışma Süresi</div>
                </div>
                <div className="text-center" data-id="element-366">
                  <CheckSquareIcon className="w-8 h-8 text-blue-400 mx-auto mb-2" data-id="element-367" />
                  <div className="text-2xl font-bold text-white" data-id="element-368">145</div>
                  <div className="text-sm text-gray-400" data-id="element-369">Çözülen Soru</div>
                </div>
                <div className="text-center" data-id="element-370">
                  <PlayIcon className="w-8 h-8 text-blue-400 mx-auto mb-2" data-id="element-371" />
                  <div className="text-2xl font-bold text-white" data-id="element-372">12</div>
                  <div className="text-sm text-gray-400" data-id="element-373">İzlenen Video</div>
                </div>
              </div>
            </div>
            {/* Parlama efekti */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-374" />
          </div>
        </div>
        {/* Gelişim Uyarıları */}
        <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-375">
          <div className="bg-black/90 rounded-lg p-6 relative overflow-hidden" data-id="element-376">
            <div className="flex items-center gap-2 mb-4" data-id="element-377">
              <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-378" />
              <h3 className="text-gray-400 font-medium text-sm" data-id="element-379">
                Gelişim Uyarıları
              </h3>
            </div>
            <div className="space-y-3" data-id="element-380">
              <div className="flex items-start gap-3 p-3 bg-yellow-500/10 border-l-4 border-yellow-500 rounded" data-id="element-381">
                <AlertTriangleIcon className="w-4 h-4 text-yellow-400 mt-0.5" data-id="element-382" />
                <span className="text-sm text-white" data-id="element-383">
                  Bu hafta Matematik performansında düşüş gözlemlendi.
                </span>
              </div>
              <div className="flex items-start gap-3 p-3 bg-green-500/10 border-l-4 border-green-500 rounded" data-id="element-384">
                <CheckCircleIcon className="w-4 h-4 text-green-400 mt-0.5" data-id="element-385" />
                <span className="text-sm text-white" data-id="element-386">
                  Tüm ödevler zamanında tamamlandı.
                </span>
              </div>
            </div>
            {/* Parlama efekti */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-387" />
          </div>
        </div>
      </div>
      {/* Haftalık Çalışma Grafiği */}
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-388">
        <div className="bg-black/90 rounded-lg p-6 relative overflow-hidden" data-id="element-389">
          <h3 className="text-gray-400 font-medium text-sm mb-4" data-id="element-390">
            Haftalık Çalışma Grafiği
          </h3>
          <div className="h-[250px]" data-id="element-391">
            <ResponsiveContainer width="100%" height="100%" data-id="element-392">
              <BarChart data={weeklyData} data-id="element-393">
                <XAxis dataKey="day" stroke="#9CA3AF" tick={{
                fontSize: 12
              }} data-id="element-394" />
                <YAxis stroke="#9CA3AF" domain={[0, 24]} ticks={[0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24]} tick={{
                fontSize: 12
              }} data-id="element-395" />
                <Tooltip formatter={value => [`${value} saat`, 'Çalışma Süresi']} contentStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.5)',
                borderRadius: '0.5rem'
              }} data-id="element-396" />
                <Bar dataKey="hours" fill="#3B82F6" data-id="element-397" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          {/* Parlama efekti */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-398" />
        </div>
      </div>
      {/* Bugün Yapılacaklar - Öğrenci panelinden veri çekecek */}
      <BugunYapilacaklar data-id="element-399" />
    </div>;
}